import React, { FC, ReactNode } from "react";

import cn from "classnames";

import styles from "./StatsBox.module.scss";

export interface StatsBoxProps {
  className?: string;
  size?: "medium" | "small";
  title: ReactNode;
  value: ReactNode;
}

const StatsBox: FC<StatsBoxProps> = ({ className, size = "medium", title, value }) => {
  return (
    <div className={cn(styles.container, styles[size], className)}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};

export default StatsBox;
